import React from "react";
import { Card, Row, Col, Divider, Tooltip } from "antd";
import classNames from "classnames";
import PropTypes from "prop-types";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

import "./StatsSummary.scss";

const Block = React.memo(({ item, className = "" }) => (
  <div className={classNames("pl-stat", className)}>
    <div className="pl-stat__label">{item.label}</div>
    <div className="pl-stat__values">
      {item.tooltip ? (
        <Tooltip title={item.tooltip}>
          <span className="pl-stat__value">{item.value}</span>
        </Tooltip>
      ) : (
        <span className="pl-stat__value">{item.value}</span>
      )}
      {item.sub && (
        <>
          <Divider type="vertical" className="pl-stats-divider" />
          <span className="pl-stat__sub">{item.sub}</span>
        </>
      )}
    </div>
  </div>
));

const NewStatsSummary = ({ ready, published, total, className }) => {
  const screens = useBreakpoint();
  const isDesktop = screens.lg || screens.xl || screens.xxl;
  return (
    <Card bordered className={classNames("stats-summary pl-stats-card", className)}>
      <Row justify="space-between">
        <Col xs={24} sm={24} md={24} lg={7} xl={7} xxl={7}>
          <Block item={ready} screens={screens} />
        </Col>
        <Col xs={24} sm={24} md={24} lg={7} xl={7} xxl={7}>
          <Block item={published} screens={screens} />
        </Col>
        {isDesktop ? (
          <div className="pl-stat">
            <Divider type="vertical" className="pl-stats-divider" style={{ height: "100px" }} />
          </div>
        ) : (
          ""
        )}
        <Col xs={24} sm={24} md={24} lg={8} xl={8} xxl={8}>
          <Block item={total} screens={screens} className="total-marketable-unit" />
        </Col>
      </Row>
    </Card>
  );
};

const PropStateShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  sub: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  tooltip: PropTypes.string.isRequired,
});

NewStatsSummary.propTypes = {
  ready: PropStateShape.isRequired,
  published: PropStateShape.isRequired,
  total: PropStateShape.isRequired,
  className: PropTypes.string,
};

Block.propTypes = {
  item: PropStateShape.isRequired,
  className: PropTypes.string,
};
export default NewStatsSummary;
